<template>
  <div>
    <ul class="contents">
      <li v-for="(child, index) in children" :key="index">
        <tree-folder
          @methodOnClick="methodOnClick"
          @getData="getData"
          @select="select"
          v-if="child.children"
          :folder="child"
          :dynamicButton="dynamicButton"
        />
        <div class="d-flex myDIV" v-else>
          <div :class="`showhim ${child.active ? `text-danger` : `text-info`}`">
            {{ child.name }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    children: {
      type: [Object, Array],
    },
    dynamicButton: {
      type: [Object, Array],
    },
  },
  methods: {
    methodOnClick(item, type) {
      this.$emit("methodOnClick", item, type);
    },
    getData(item) {
      this.$emit("getData", item);
    },
    select(item) {
      this.$emit("select", item);
    },
  },
};
</script>

<style>
</style>
